/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as ResetMfaRouteImport } from './routes/reset-mfa'
import { Route as InviteTermsRouteImport } from './routes/invite-terms'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as LoginRouteRouteImport } from './routes/login/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LoginVerifyEmailRouteImport } from './routes/login/verify-email'
import { Route as LoginVerifyAppRouteImport } from './routes/login/verify-app'
import { Route as AuthVerificationsRouteImport } from './routes/_auth/verifications'
import { Route as AuthUserManagementRouteImport } from './routes/_auth/user-management'
import { Route as AuthUnauthorizedRouteImport } from './routes/_auth/unauthorized'
import { Route as AuthSystemRouteImport } from './routes/_auth/system'
import { Route as AuthSupportRouteImport } from './routes/_auth/support'
import { Route as AuthLearnCentreRouteImport } from './routes/_auth/learn-centre'
import { Route as AuthAccountsRouteImport } from './routes/_auth/accounts'
import { Route as AuthAccountSettingsRouteImport } from './routes/_auth/account-settings'
import { Route as LoginSetupAuthenticatorIndexRouteImport } from './routes/login/setup-authenticator/index'
import { Route as LoginSetupAuthenticatorManualKeyRouteImport } from './routes/login/setup-authenticator/manual-key'

const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetMfaRoute = ResetMfaRouteImport.update({
  id: '/reset-mfa',
  path: '/reset-mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTermsRoute = InviteTermsRouteImport.update({
  id: '/invite-terms',
  path: '/invite-terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginVerifyEmailRoute = LoginVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginVerifyAppRoute = LoginVerifyAppRouteImport.update({
  id: '/verify-app',
  path: '/verify-app',
  getParentRoute: () => LoginRouteRoute,
} as any)
const AuthVerificationsRoute = AuthVerificationsRouteImport.update({
  id: '/verifications',
  path: '/verifications',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthUserManagementRoute = AuthUserManagementRouteImport.update({
  id: '/user-management',
  path: '/user-management',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthUnauthorizedRoute = AuthUnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSystemRoute = AuthSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSupportRoute = AuthSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLearnCentreRoute = AuthLearnCentreRouteImport.update({
  id: '/learn-centre',
  path: '/learn-centre',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAccountsRoute = AuthAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAccountSettingsRoute = AuthAccountSettingsRouteImport.update({
  id: '/account-settings',
  path: '/account-settings',
  getParentRoute: () => AuthRouteRoute,
} as any)
const LoginSetupAuthenticatorIndexRoute =
  LoginSetupAuthenticatorIndexRouteImport.update({
    id: '/setup-authenticator/',
    path: '/setup-authenticator/',
    getParentRoute: () => LoginRouteRoute,
  } as any)
const LoginSetupAuthenticatorManualKeyRoute =
  LoginSetupAuthenticatorManualKeyRouteImport.update({
    id: '/setup-authenticator/manual-key',
    path: '/setup-authenticator/manual-key',
    getParentRoute: () => LoginRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRouteRouteWithChildren
  '/admin': typeof AdminRoute
  '/invite-terms': typeof InviteTermsRoute
  '/reset-mfa': typeof ResetMfaRoute
  '/verify': typeof VerifyRoute
  '/account-settings': typeof AuthAccountSettingsRoute
  '/accounts': typeof AuthAccountsRoute
  '/learn-centre': typeof AuthLearnCentreRoute
  '/support': typeof AuthSupportRoute
  '/system': typeof AuthSystemRoute
  '/unauthorized': typeof AuthUnauthorizedRoute
  '/user-management': typeof AuthUserManagementRoute
  '/verifications': typeof AuthVerificationsRoute
  '/login/verify-app': typeof LoginVerifyAppRoute
  '/login/verify-email': typeof LoginVerifyEmailRoute
  '/login/': typeof LoginIndexRoute
  '/login/setup-authenticator/manual-key': typeof LoginSetupAuthenticatorManualKeyRoute
  '/login/setup-authenticator/': typeof LoginSetupAuthenticatorIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/invite-terms': typeof InviteTermsRoute
  '/reset-mfa': typeof ResetMfaRoute
  '/verify': typeof VerifyRoute
  '/account-settings': typeof AuthAccountSettingsRoute
  '/accounts': typeof AuthAccountsRoute
  '/learn-centre': typeof AuthLearnCentreRoute
  '/support': typeof AuthSupportRoute
  '/system': typeof AuthSystemRoute
  '/unauthorized': typeof AuthUnauthorizedRoute
  '/user-management': typeof AuthUserManagementRoute
  '/verifications': typeof AuthVerificationsRoute
  '/login/verify-app': typeof LoginVerifyAppRoute
  '/login/verify-email': typeof LoginVerifyEmailRoute
  '/login': typeof LoginIndexRoute
  '/login/setup-authenticator/manual-key': typeof LoginSetupAuthenticatorManualKeyRoute
  '/login/setup-authenticator': typeof LoginSetupAuthenticatorIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/login': typeof LoginRouteRouteWithChildren
  '/admin': typeof AdminRoute
  '/invite-terms': typeof InviteTermsRoute
  '/reset-mfa': typeof ResetMfaRoute
  '/verify': typeof VerifyRoute
  '/_auth/account-settings': typeof AuthAccountSettingsRoute
  '/_auth/accounts': typeof AuthAccountsRoute
  '/_auth/learn-centre': typeof AuthLearnCentreRoute
  '/_auth/support': typeof AuthSupportRoute
  '/_auth/system': typeof AuthSystemRoute
  '/_auth/unauthorized': typeof AuthUnauthorizedRoute
  '/_auth/user-management': typeof AuthUserManagementRoute
  '/_auth/verifications': typeof AuthVerificationsRoute
  '/login/verify-app': typeof LoginVerifyAppRoute
  '/login/verify-email': typeof LoginVerifyEmailRoute
  '/login/': typeof LoginIndexRoute
  '/login/setup-authenticator/manual-key': typeof LoginSetupAuthenticatorManualKeyRoute
  '/login/setup-authenticator/': typeof LoginSetupAuthenticatorIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/invite-terms'
    | '/reset-mfa'
    | '/verify'
    | '/account-settings'
    | '/accounts'
    | '/learn-centre'
    | '/support'
    | '/system'
    | '/unauthorized'
    | '/user-management'
    | '/verifications'
    | '/login/verify-app'
    | '/login/verify-email'
    | '/login/'
    | '/login/setup-authenticator/manual-key'
    | '/login/setup-authenticator/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/invite-terms'
    | '/reset-mfa'
    | '/verify'
    | '/account-settings'
    | '/accounts'
    | '/learn-centre'
    | '/support'
    | '/system'
    | '/unauthorized'
    | '/user-management'
    | '/verifications'
    | '/login/verify-app'
    | '/login/verify-email'
    | '/login'
    | '/login/setup-authenticator/manual-key'
    | '/login/setup-authenticator'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/admin'
    | '/invite-terms'
    | '/reset-mfa'
    | '/verify'
    | '/_auth/account-settings'
    | '/_auth/accounts'
    | '/_auth/learn-centre'
    | '/_auth/support'
    | '/_auth/system'
    | '/_auth/unauthorized'
    | '/_auth/user-management'
    | '/_auth/verifications'
    | '/login/verify-app'
    | '/login/verify-email'
    | '/login/'
    | '/login/setup-authenticator/manual-key'
    | '/login/setup-authenticator/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  LoginRouteRoute: typeof LoginRouteRouteWithChildren
  AdminRoute: typeof AdminRoute
  InviteTermsRoute: typeof InviteTermsRoute
  ResetMfaRoute: typeof ResetMfaRoute
  VerifyRoute: typeof VerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-mfa': {
      id: '/reset-mfa'
      path: '/reset-mfa'
      fullPath: '/reset-mfa'
      preLoaderRoute: typeof ResetMfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite-terms': {
      id: '/invite-terms'
      path: '/invite-terms'
      fullPath: '/invite-terms'
      preLoaderRoute: typeof InviteTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/verify-email': {
      id: '/login/verify-email'
      path: '/verify-email'
      fullPath: '/login/verify-email'
      preLoaderRoute: typeof LoginVerifyEmailRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/verify-app': {
      id: '/login/verify-app'
      path: '/verify-app'
      fullPath: '/login/verify-app'
      preLoaderRoute: typeof LoginVerifyAppRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/_auth/verifications': {
      id: '/_auth/verifications'
      path: '/verifications'
      fullPath: '/verifications'
      preLoaderRoute: typeof AuthVerificationsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/user-management': {
      id: '/_auth/user-management'
      path: '/user-management'
      fullPath: '/user-management'
      preLoaderRoute: typeof AuthUserManagementRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/unauthorized': {
      id: '/_auth/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof AuthUnauthorizedRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/system': {
      id: '/_auth/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof AuthSystemRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/support': {
      id: '/_auth/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthSupportRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/learn-centre': {
      id: '/_auth/learn-centre'
      path: '/learn-centre'
      fullPath: '/learn-centre'
      preLoaderRoute: typeof AuthLearnCentreRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/accounts': {
      id: '/_auth/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AuthAccountsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/account-settings': {
      id: '/_auth/account-settings'
      path: '/account-settings'
      fullPath: '/account-settings'
      preLoaderRoute: typeof AuthAccountSettingsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/login/setup-authenticator/': {
      id: '/login/setup-authenticator/'
      path: '/setup-authenticator'
      fullPath: '/login/setup-authenticator/'
      preLoaderRoute: typeof LoginSetupAuthenticatorIndexRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/setup-authenticator/manual-key': {
      id: '/login/setup-authenticator/manual-key'
      path: '/setup-authenticator/manual-key'
      fullPath: '/login/setup-authenticator/manual-key'
      preLoaderRoute: typeof LoginSetupAuthenticatorManualKeyRouteImport
      parentRoute: typeof LoginRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthAccountSettingsRoute: typeof AuthAccountSettingsRoute
  AuthAccountsRoute: typeof AuthAccountsRoute
  AuthLearnCentreRoute: typeof AuthLearnCentreRoute
  AuthSupportRoute: typeof AuthSupportRoute
  AuthSystemRoute: typeof AuthSystemRoute
  AuthUnauthorizedRoute: typeof AuthUnauthorizedRoute
  AuthUserManagementRoute: typeof AuthUserManagementRoute
  AuthVerificationsRoute: typeof AuthVerificationsRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAccountSettingsRoute: AuthAccountSettingsRoute,
  AuthAccountsRoute: AuthAccountsRoute,
  AuthLearnCentreRoute: AuthLearnCentreRoute,
  AuthSupportRoute: AuthSupportRoute,
  AuthSystemRoute: AuthSystemRoute,
  AuthUnauthorizedRoute: AuthUnauthorizedRoute,
  AuthUserManagementRoute: AuthUserManagementRoute,
  AuthVerificationsRoute: AuthVerificationsRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface LoginRouteRouteChildren {
  LoginVerifyAppRoute: typeof LoginVerifyAppRoute
  LoginVerifyEmailRoute: typeof LoginVerifyEmailRoute
  LoginIndexRoute: typeof LoginIndexRoute
  LoginSetupAuthenticatorManualKeyRoute: typeof LoginSetupAuthenticatorManualKeyRoute
  LoginSetupAuthenticatorIndexRoute: typeof LoginSetupAuthenticatorIndexRoute
}

const LoginRouteRouteChildren: LoginRouteRouteChildren = {
  LoginVerifyAppRoute: LoginVerifyAppRoute,
  LoginVerifyEmailRoute: LoginVerifyEmailRoute,
  LoginIndexRoute: LoginIndexRoute,
  LoginSetupAuthenticatorManualKeyRoute: LoginSetupAuthenticatorManualKeyRoute,
  LoginSetupAuthenticatorIndexRoute: LoginSetupAuthenticatorIndexRoute,
}

const LoginRouteRouteWithChildren = LoginRouteRoute._addFileChildren(
  LoginRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  LoginRouteRoute: LoginRouteRouteWithChildren,
  AdminRoute: AdminRoute,
  InviteTermsRoute: InviteTermsRoute,
  ResetMfaRoute: ResetMfaRoute,
  VerifyRoute: VerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
